<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space import-costsprice-dialog">
    <sc-dialog-title>
      {{ 'Artikel Einkaufspreise importieren' | translate: ['erp.ui.import-costsprice-catalog.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div>
          <form [formGroup]="formGroup">
            <sc-flex >
              <mat-form-field appearance="fill">
                  <mat-label>{{ 'Von' | translate: ['erp.entity.price.valid-from', translationService.language]}}</mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="date_from" required="true" type="date-local">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field appearance="fill" class="date-field">
                  <mat-label>{{ 'Bis' | translate: ['erp.entity.price.valid-until', translationService.language]}}</mat-label>
                  <input matInput [matDatepicker]="picker2" formControlName="date_until" type="date-local">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </sc-flex>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div>
              <sc-flex >
                <button mat-flat-button (click)="chooseFile()">
                  {{'Choose Costsprice Excel'| translate: ['erp.ui.import-costsprice-catalog.action.choose-file', translationService.language]}}
                </button>
                <input #fileChooser type="file" class="fileupload-field" (change)="onFileSelected($event)" #fileUpload accept=".xlsx">
                <sc-content-spacer></sc-content-spacer>
                <sc-flex-fitting-content>
                  <span>{{costsPriceImportData?.file?.name}}</span>
                </sc-flex-fitting-content>

              </sc-flex>
            </div>
          </form>
        </div>
        <div *ngIf="importRunning">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          {{'Import running...' | translate: ['erp.ui.import-costsprice-catalog.import-running', translationService.language]}}
          <i class="spinner fa-light fa-spinner fa-spin"></i>
        </div>
        <div *ngIf="importRequestFailed">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          Datei konnte nicht übertragen werden.
        </div>
        <div class="importErrors" *ngIf="hasImportErrors">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <div>
            {{'Nicht kürzbar' | translate: ['erp.ui.import-costsprice-catalog.error.costsprice-period-not-modifiable', translationService.language]}}
          </div>
          <div class="article-error-list">
            <sc-scroll-pane>
              <div class="article-error-entry" *ngFor="let identifier of articlesWithNotModifiableCostsPrices">
                {{identifier}}
              </div>
            </sc-scroll-pane>
          </div>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.import-costsprice-catalog.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          {{ 'Übernehmen' | translate: ['erp.ui.import-costsprice-catalog.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
